module.exports = __webpack_public_path__ + "static/media/delete.4cc4ab71.svg";